import React, { useMemo } from 'react';
import { Col, Image, Row } from 'react-bootstrap'
import { ReactComponent as TierArrow } from '@assets/tier-arrow.svg'
import { ReactComponent as PillBottom } from '@assets/half-circle.svg'
import { ReactComponent as PillTop } from '@assets/half-circle-down.svg'
import { FlameTier, FlameTiers } from '@contracts/hooks/useFlameTier/constants';
import './FlameLevelMobile.scss';
import { usePlatformSettings } from '@hooks/usePlatformSettings';
import { numberToCurrency } from '@utils/balanceFormatter';

interface Props {
  currentTier: FlameTier | null
}

const Tier = (props: { currentTier: string | null, breakpoint: number, title: FlameTier, children: React.ReactNode }) =>
  <div className="item">
    <div className="icon">
      {props.currentTier === props.title && <TierArrow className="arrow" />}
      {props.children}
    </div>
    <div className="description">
      <div className="title">
        {props.title}
      </div>
      <div className="subtitle">
        {`${numberToCurrency(props.breakpoint)}+ FLAME POWER`}
      </div>
    </div>
  </div>

const Pill = () =>
  <div className="pill">
    <PillTop />
    <PillBottom />
  </div>

const FlameLevelMobile = ({ currentTier }: Props) => {
  const { settings } = usePlatformSettings()
  const tiers = useMemo(() => settings?.tiers ?? [], [settings])
  const tierIndex: number = useMemo(() => {
    return tiers.findIndex(t => t.name === currentTier)
  }, [currentTier, tiers])

  const reversedTiers = useMemo(() => [...tiers].reverse(), [tiers])

  const overlayWidth: number = useMemo(() => {
    if (tierIndex === -1) return 0
    if (tierIndex === tiers.length - 1) return 100
    return (100 / tiers.length) * (tierIndex + 1)
  }, [tierIndex])

  return (
    <Row className="mobile-heat-row gx-0">
      <Col xs={1}>
        <div className="color-strip">
          <div className="pills">
            {reversedTiers.map((tier) => <Pill key={tier.name} />)}
          </div>
          <div
            className='color-strip__overlay'
            style={{ height: `${overlayWidth}%`, }}
          />
        </div>
      </Col>
      <Col className="text-left column" xs={11}>
        <div className="progress">
          {reversedTiers.map((tier) => (
            <Tier
              key={tier.name}
              currentTier={currentTier}
              breakpoint={tier.min_flame_power}
              title={tier.name}
            >
              <Image src={tier.icon} />
            </Tier>
          ))}
        </div>
      </Col>
    </Row>
  );
};

FlameLevelMobile.defaultProps = {
  currentTier: FlameTiers.FLAME
}

export { FlameLevelMobile }
